import { RouterStore } from '@estee/elc-router';

import { genericErrorMessage, SocialProfileSearchParams } from '~constants/Constants';
import { SignInType } from '~constants/SignInTypeEnum';
import { SocialCallbackQueryParams } from '~constants/SocialConstants';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { MessageGroup, MessageRepository } from '~repositories/MessageRepository';
import { UserRepository } from '~repositories/UserRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

import { getSocialProviderFromState } from '../utils/SocialUtils';
import { PrefillUserFormUseCase } from './PrefillUserFormUseCase';

export class SocialProfileLoadedUseCase {
    private userRepository: UserRepository;
    private configRepository: ConfigRepository;
    private routerStore: RouterStore;
    private messageRepository: MessageRepository;

    constructor() {
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.routerStore = diContainer.get(serviceNames.routerStore);
        this.messageRepository = diContainer.get(serviceNames.messageRepository);
    }

    execute = async () => {
        const { setSocialProvider, setSocialRedirectUrl } = this.configRepository;
        const { queryParams } = this.routerStore;
        const socialCallbackState = decodeURI(
            new URLSearchParams(window.location.search).get(SocialCallbackQueryParams.STATE) || ''
        );
        //social provider from OAuth callback state
        const socialProvider = getSocialProviderFromState(socialCallbackState) as SignInType;
        //social provider from direct url
        const provider = queryParams[SocialProfileSearchParams.PROVIDER] || socialProvider;
        const redirectUrl = queryParams[SocialProfileSearchParams.REDIRECT_URL];
        if (!provider) {
            console.error('No provider specified');
        } else {
            const { consentForm, loadSocialProfile } = this.userRepository;
            setSocialProvider(provider);
            setSocialRedirectUrl(redirectUrl);
            let profile = { emailAddress: '' };
            try {
                profile = await loadSocialProfile(provider);
            } catch (e) {
                this.messageRepository.setMessages(MessageGroup.SIGN_UP, [
                    { transKey: genericErrorMessage }
                ]);
            } finally {
                await new PrefillUserFormUseCase(provider, profile).execute();
                consentForm.setFormFilled(true);
            }
        }
    };
}
